import Vue from 'vue'
import Router from 'vue-router'
import HelloWorld from '@/components/HelloWorld'
import kanban1 from '@/views/kanban1'

Vue.use(Router)

export default new Router({
  routes: [
    {
      path: '/',
      name: 'kanban',
      component: kanban1
    }
  ]
})



// WEBPACK FOOTER //
// ./src/router/index.js